import { render, staticRenderFns } from "./dialog-alertcontactadmin.vue?vue&type=template&id=686cbc7d&"
import script from "./dialog-alertcontactadmin.vue?vue&type=script&lang=js&"
export * from "./dialog-alertcontactadmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports